import CommonUiModel from "../common/commonUiModel";

const equipmentScopeConfig = {
    title: "Equipment Scope",
    api: "EquipmentScope",
    showHistory: false,
    hideBreadcrumb: true,
    reloadOnSave: true,
    module: 'ScopeMaster',
    navigateBack: -1,
    columns: [
        { field: 'HuluScopeFamily', gridLabel: 'Scope Family', label: null },
        { field: 'ScopeTypeId', gridLabel: 'Scope Type', readOnly: true, type: 'select', width: 200, lookup: 'ScopeType', label: null },
        { field: 'ManufacturerId', gridLabel: 'Equipment Type', type: 'select', width: 200, lookup: 'Manufacturer', label: null },
        { field: 'ScopeModel', gridLabel: 'Scope Model', label: null },
        { field: 'StatusId', gridLabel: 'Status', type: 'select', width: 200, lookup: 'ScopeStatus', label: null },
        { field: 'Channels', gridLabel: 'Channels', readOnly: true, label: null },
        { field: 'MaxScopesPerBasin', type: 'number', width: 200, label: 'Max Scopes Per Basin', min: 1, max: '{EquipmentMaxScopesPerBasin}' },
        { field: 'Alcohol', label: 'Use Alcohol', type: 'boolean', width: 200 },
        { field: 'Notes', gridLabel: 'Notes', multiline: true, label: null },
        { field: "EquipmentScopeRegion", label: "Regions", lookup: 'Region', type: "autocomplete", filterable: false, sortable: false, required: false, gridLabel: null }
    ]
};
const EquipmentScope = new CommonUiModel(equipmentScopeConfig);
export { equipmentScopeConfig };
export default EquipmentScope;